import type { paths } from "@/api-schema";
import { alphartisApiAxios } from "@/config/axios";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import {
  VEHICLE_VALUATION_SETTINGS_API_PATH,
  VEHICLE_VALUATION_SETTINGS_RESOURCE,
} from "./use-vehicle-valuation-settings-get.query";

type VehicleValuationSettingsPutBody =
  paths[typeof VEHICLE_VALUATION_SETTINGS_API_PATH]["put"]["requestBody"]["content"]["application/json"];
type VehicleValuationSettingsPutResponse =
  paths[typeof VEHICLE_VALUATION_SETTINGS_API_PATH]["put"]["responses"][200]["content"]["application/json"];

export function useVehicleValuationSettingsUpdateMutation() {
  const queryClient = useQueryClient();

  return useMutation<VehicleValuationSettingsPutResponse, Error, VehicleValuationSettingsPutBody>({
    mutationFn: async (body) => {
      const response = await alphartisApiAxios.put<VehicleValuationSettingsPutResponse>(
        VEHICLE_VALUATION_SETTINGS_API_PATH,
        body,
      );

      return response.data;
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: [VEHICLE_VALUATION_SETTINGS_RESOURCE],
      });
    },
  });
}
